// Auto-generated translation for ro.
// Source: landings.js, translated via Claude Sonnet on 2026-05-26T11:23:59.157691+00:00.

export const LANDINGS = {
  "eigen-paard": {
    slug: "eigen-paard",
    eyebrow: "Pentru proprietarii de cai",
    title: "Tot ce ai nevoie pentru calul tău. Într-o singură aplicație.",
    subtitle: "Gestionează sănătatea, antrenamentul, programările și profesioniștii dintr-un singur dosar organizat.",
    primaryCTA: {
      label: "Începe gratuit",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Vezi Premium",
      href: "/premium",
    },
    heroScreenshot: {
      url: "/assets/owner-horse.png",
      alt: "Profilul calului — greutate, vaccinare, EquiCoach, nutriție și antrenament într-un singur ecran",
      caption: "Calul tău, complet în imagine.",
    },
    problem: "Cel mai probabil îți ții programările, fotografiile, antrenamentele, nutriția și sănătatea împrăștiate — în grupuri de WhatsApp, cutii de pantofi și aplicații separate. Astfel pierzi controlul de ansamblu.",
    solution: "EquiSight transformă calul tău într-un dosar digital complet care te însoțește oriunde.",
    benefits: [
      "Un profil complet per cal",
      "Sănătate, potcovar, dentist și fizioterapeut într-un singur loc",
      "Agendă cu memento-uri inteligente",
      "Fotografii, notițe și istoric fără limită",
      "Backup pentru toate datele tale la Premium",
    ],
    pricing: {
      tiers: [
        {
          name: "Basic",
          price: "€0",
          note: "1 cal · întotdeauna gratuit",
        },
        {
          name: "Premium",
          price: "€4,99",
          note: "Mai mulți cai + backup",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Gata de start?",
      title: "Începe astăzi cu primul tău cal.",
      href: "/#waitlist",
    },
  },
  "premium": {
    slug: "premium",
    eyebrow: "Premium",
    title: "Mai mulți cai. Mai multă claritate. Mai multă siguranță.",
    subtitle: "Fă upgrade la Premium și gestionează toți caii tăi fără limitări — cu toată inteligența EquiCoach.",
    primaryCTA: {
      label: "Începe 14 zile gratuit",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Toate prețurile",
      href: "/#pricing",
    },
    audience: "Pentru proprietari, călăreți sportivi și crescători cu mai mulți cai.",
    features: [
      "Adaugă cai nelimitat",
      "Istoric complet per cal",
      "Backup date",
      "Perspective extinse EquiCoach",
      "Notificări inteligente și planificare",
      "Sănătate și antrenament complet integrate",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Mai puțin de €0,17 pe zi",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Ești pregătit?",
      title: "Fă upgrade la Premium.",
      href: "/#waitlist",
    },
  },
  "manege-ruiter": {
    slug: "manege-ruiter",
    eyebrow: "Pentru călăreții de manej",
    title: "Devino mai bun, chiar și fără propriul cal.",
    subtitle: "Urmărește-ți lecțiile, antrenamentele și progresul în EquiSight — pentru mai puțin decât o cafea pe lună pentru tată sau mamă. Sau o înghețată delicioasă cu frișcă.",
    primaryCTA: {
      label: "Începe cu Premium",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Cum funcționează?",
      href: "#features",
    },
    problem: "Ca și călăreț de manej, adesea nu ai propriul cal, dar vrei totuși să progresezi și să ai o privire de ansamblu asupra lecțiilor, obiectivelor și cailor pe care îi călărești.",
    solution: "Funcționalitatea pentru manej este inclusă implicit în Premium — urmărește-ți propria dezvoltare și vizualizează caii de manej asociați în mod read-only.",
    features: [
      "Înregistrarea antrenamentelor",
      "Stabilirea obiectivelor",
      "Urmărirea progresului",
      "Vizualizarea cailor de manej cu nume și fotografie",
      "Fără acces la datele private de sănătate",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Pe lună · funcționalitate manej inclusă",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Devino membru",
      title: "Începe ca și călăreț de manej.",
      href: "/#waitlist",
    },
  },
  "manege-module": {
    slug: "manege-module",
    eyebrow: "Pentru manege & grajduri",
    title: "Fă manegea ta accesibilă digital pentru fiecare călăreț.",
    subtitle: "Oferă călăreților o legătură cu caii, lecțiile și progresul — fără a partaja date sensibile ale grajdului.",
    primaryCTA: {
      label: "Solicită acces",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Vezi modulele",
      href: "#features",
    },
    audience: "EquiSight ajută manegele și grajdurile să mențină călăreții implicați mai mult timp și să se diferențieze digital.",
    features: [
      "Fă caii de manej vizibili pentru călăreți",
      "Nume și fotografie pentru fiecare cal",
      "Asociază călăreții cu caii",
      "Acces doar pentru citire pentru datele cu caracter privat",
      "Istoricul lecțiilor și antrenamentelor centralizat",
      "Gestionarea utilizatorilor cu roluri",
    ],
    benefits: [
      "Mai multă implicare din partea călăreților",
      "Imagine mai profesională",
      "Serviciu digital suplimentar pentru membri",
      "Sursă nouă de venit prin utilizarea aplicației",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Pe lună · funcționalitate manege inclusă pentru călăreți",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Gata?",
      title: "Activează Modulul Manege.",
      href: "/#waitlist",
    },
  },
  "fokkerij": {
    slug: "fokkerij",
    eyebrow: "Modul reproducție",
    title: "Control asupra ciclului, gestației și dezvoltării mânzului.",
    subtitle: "Modulul complet de reproducție pentru proprietarii de iepe și crescători — de la montă până la mânz, într-o singură cronologie.",
    primaryCTA: {
      label: "Activează Modulul de Reproducție",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Vezi funcțiile",
      href: "#features",
    },
    audience: "Pentru crescători, proprietari de iepe și grajduri care gestionează mai multe iepe.",
    features: [
      "Urmărirea ciclului",
      "Înregistrarea căldurilor",
      "Înregistrarea datelor de însămânțare",
      "Numărătoare inversă până la ecografii",
      "Planificarea controalelor de gestație",
      "Arbore genealogic și descendență",
      "Dezvoltarea mânzului",
      "Prezentare generală a tuturor iepelor gestante",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Pe lună · Modulul de reproducție inclus în Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Începe astăzi",
      title: "Începe gestionarea reproducției.",
      href: "/#waitlist",
    },
  },
  "hoefsmid": {
    slug: "hoefsmid",
    eyebrow: "Modulul pentru potcovari",
    title: "Lucrează mai inteligent ca potcovar. Înregistrează totul profesional.",
    subtitle: "Agendă, fotografii, observații și istoricul tratamentelor într-un singur modul — mai puțină comunicare greșită, dosar mai solid.",
    primaryCTA: {
      label: "Începe ca potcovar",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Vezi Pachetul Professional",
      href: "/professional",
    },
    audience: "Pentru potcovari care doresc să îmbunătățească organizarea, documentarea și comunicarea cu clienții.",
    features: [
      "Agendă proprie",
      "Programări per client",
      "Vizualizare profiluri cai",
      "Adăugare fotografii înainte și după",
      "Notarea tratamentului",
      "Înregistrare sfaturi și observații",
      "Notificare ETA către client: \"Potcovarul este pe drum\"",
    ],
    benefits: [
      "Mod de lucru mai profesional",
      "Mai puțină comunicare greșită",
      "Construirea unui dosar mai bun",
      "Poziție mai puternică în cazul răspunderii",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Pe lună · Modulul pentru potcovari inclus în Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Gata?",
      title: "Activează Modulul pentru Potcovari.",
      href: "/#waitlist",
    },
  },
  "paardentandarts": {
    slug: "paardentandarts",
    eyebrow: "Modul stomatologie",
    title: "Un dosar stomatologic complet pentru fiecare cal.",
    subtitle: "Înregistrați constatările, tratamentele și urmărirea direct în EquiSight.",
    primaryCTA: {
      label: "Începeți ca stomatolog ecvin",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Vezi Pachetul Professional",
      href: "/professional",
    },
    audience: "Stomatologi ecvini, medici veterinari și cabinete care doresc să lucreze structurat.",
    features: [
      "Înregistrarea controlului dentar",
      "Constatări per tratament",
      "Adăugare fotografii",
      "Raport pentru proprietar",
      "Recomandări de urmărire",
      "Istoric per cal",
      "Programarea unei noi consultații",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Pe lună · Modulul stomatologie inclus în Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pregătit?",
      title: "Activați Modulul Stomatologie.",
      href: "/#waitlist",
    },
  },
  "fysio-osteo": {
    slug: "fysio-osteo",
    eyebrow: "Modul Fizioterapie / Osteopatie",
    title: "Urmărește corpul, mișcarea și recuperarea în mod profesional.",
    subtitle: "Pentru fizioterapeuți și osteopați care doresc să însoțească caii în mod structurat.",
    primaryCTA: {
      label: "Începe ca fizioterapeut/osteopat",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Vezi Pachetul Professional",
      href: "/professional",
    },
    features: [
      "Intake per cal",
      "Înregistrarea constatărilor corporale",
      "Adăugare fotografii și videoclipuri",
      "Crearea raportului de tratament",
      "Distribuirea exercițiilor și a urmăririi",
      "Urmărirea traseului de recuperare",
      "Istoric per cal",
    ],
    benefits: [
      "Perspectivă mai bună în timp",
      "Raportare profesională",
      "Comunicare clară cu proprietarul, antrenorul și călărețul",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Pe lună · Modulul Fizioterapie / Osteopatie inclus în Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Gata?",
      title: "Activează Modulul Fizioterapie / Osteopatie.",
      href: "/#waitlist",
    },
  },
  "trainer": {
    slug: "trainer",
    eyebrow: "Modul antrenor",
    title: "Antrenează călăreți cu date, obiective și progres.",
    subtitle: "Fă antrenamentul măsurabil și îndrumarea mai profesionistă — pentru unul sau mai mulți călăreți.",
    primaryCTA: {
      label: "Începe ca antrenor",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Vezi pachetul Pro",
      href: "/#pricing",
    },
    audience: "Pentru instructori, antrenori și coaches cu mai mulți călăreți sau cai.",
    features: [
      "Conectează călăreți",
      "Urmărește caii",
      "Stabilește obiective de antrenament",
      "Oferă feedback",
      "Analizează rezultatele la concursuri",
      "Vizualizează progresul per combinație",
      "Folosește analize de protocol pentru focusul antrenamentului",
    ],
    benefits: [
      "Îndrumare mai bună",
      "Mai multă structură",
      "Comunicare mai profesionistă",
      "Relație mai strânsă cu clienții",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Pe lună · Modulul antrenor inclus în Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pregătit?",
      title: "Activează Modulul Antrenor.",
      href: "/#waitlist",
    },
  },
  "wedstrijdanalyse": {
    slug: "wedstrijdanalyse",
    eyebrow: "Analiză competițională",
    title: "De la protocol la îmbunătățirea performanței.",
    subtitle: "Încarcă protocolul tău de concurs și descoperă unde pierzi puncte — nu doar să îți vezi scorul, ci să înțelegi cum poți progresa.",
    primaryCTA: {
      label: "Analizează primul tău protocol",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Vezi Premium",
      href: "/premium",
    },
    features: [
      "Încărcare fotografie protocol",
      "Procesare față și verso",
      "Recunoașterea clasei, numărului de probă și al juriului",
      "Analiza scorurilor pe elemente",
      "Rezumarea comentariilor",
      "Afișarea punctelor forte și slabe",
      "Tendințe pe combinație cal-călăreț",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Pe lună · analiza competițională inclusă începând cu Premium",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Gata?",
      title: "Începe analiza competițională.",
      href: "/#waitlist",
    },
  },
  "professional": {
    slug: "professional",
    eyebrow: "Pachet Professional",
    title: "Pentru profesioniștii din jurul calului.",
    subtitle: "Potcovar, dentist, fizioterapeut, osteopat sau antrenor: colaborați într-un singur dosar digital al calului.",
    primaryCTA: {
      label: "Începeți ca profesionist",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Vezi modulele individuale",
      href: "#features",
    },
    audience: "Pachetul Professional combină toate modulele de specialitate într-un singur abonament.",
    features: [
      "Modul Potcovar",
      "Modul Dentist",
      "Modul Fizioterapie / Osteopatie",
      "Agendă și gestionare clienți",
      "Profiluri cai și rapoarte",
      "Istoricul tratamentelor și construirea dosarului",
      "Comunicare cu proprietarul",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Pe lună · toate modulele de specialitate incluse",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pregătit?",
      title: "Alege Professional.",
      href: "/#waitlist",
    },
  },
  "noodnummerpaard": {
    slug: "noodnummerpaard",
    eyebrow: "Numere de urgență cal",
    title: "Întotdeauna ajutorul potrivit la îndemână.",
    subtitle: "Într-o urgență, fiecare secundă contează. Cu EquiSight ai toate datele de contact importante ale calului tău imediat disponibile — un singur tap și suni.",
    primaryCTA: {
      label: "Pregătește-ți contactele de urgență",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Începe gratuit cu EquiSight",
      href: "/#waitlist",
    },
    accent: "danger",
    heroScreenshot: {
      url: "/assets/emergency.png",
      alt: "Contacte de urgență — sună direct, trimite WhatsApp sau navighează către veterinar, clinică și potcovar",
      caption: "Un singur tap. Fără panică.",
      embeddedFrame: true,
    },
    problem: "Calul tău are ceva — colici, accidentare, panică. Și atunci începe căutarea. Pe cine suni? Ai numărul corect? Este acesta numărul de urgență? Timp prețios se pierde.",
    solution: "Cu EquiSight ai totul imediat la îndemână. Fără căutare. Fără ezitare. Un singur tap și ești în contact.",
    scenario: {
      title: "Imaginează-ți — calul tău prezintă simptome de colici.",
      steps: [
        "Deschizi EquiSight",
        "Apeși pe \"Veterinar\"",
        "Suni direct",
      ],
      tagline: "Fără stres. Fără căutare. Doar acțiune.",
    },
    features: [
      "Toate numerele de urgență într-un singur loc",
      "Apeluri cu un singur tap din aplicație",
      "WhatsApp cu un singur tap",
      "Navigare directă către adresă",
      "Listă de contacte proprie pentru fiecare cal",
      "Veterinar, clinică, potcovar, dentist, fizioterapeut",
      "Adresă + indicații de orientare disponibile imediat",
      "Marchează numerele favorite cu o stea",
      "Numere de urgență (112, 144) întotdeauna în vârf",
    ],
    benefits: [
      "Calm și control într-o situație de urgență",
      "Toată lumea din grajd are aceleași numere la îndemână",
      "Nu mai uiți cărți de vizită",
      "Reacționezi cu câteva secunde mai rapid în urgențe",
    ],
    audience: "Pentru proprietarii de cai, îngrijitori, antrenori și grajduri — oricine este responsabil pentru un cal.",
    showcase: {
      eyebrow: "Configurat în prealabil pentru tine",
      title: "13 categorii de contacte — gata de completat.",
      description: "De la veterinar și clinică de urgență până la șelar, instructor și administrator de pășune. EquiSight îți cunoaște lumea și pregătește pentru tine câmpurile de contact potrivite. Apasă, completează, gata.",
      bullets: [
        "Urgență și sănătate — veterinar, urgențe, clinică, linie toxicologie",
        "Îngrijire zilnică — potcovar, dentist, fizioterapeut, instructor",
        "Grajd și pășune — proprietar grajd, administrator pășune, pensiune ecvestră",
        "Furaje și materiale — furnizori de fân, concentrate, paie",
      ],
      image: {
        url: "/assets/emergency-manage.png",
        alt: "Ecran de gestionare contacte de urgență — toate contactele sugerate pe categorie",
        embeddedFrame: true,
      },
    },
    checklist: {
      title: "Listă de verificare numere de urgență cal",
      items: [
        "Veterinar",
        "Clinică de urgență (24/7)",
        "Ambulanță animale · 144",
        "Potcovar",
        "Persoană de contact de rezervă",
        "Număr general de urgență · 112",
      ],
      cta: {
        label: "Deschide în EquiSight și completează imediat",
        href: "/#waitlist",
      },
    },
    pricing: {
      tiers: [
        {
          name: "Numere de urgență",
          price: "Gratis",
          note: "Întotdeauna gratuit · pentru toată lumea, în orice abonament",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Asigură-te că ești pregătit",
      title: "Înainte să fie necesar.",
      href: "/#waitlist",
    },
    microcopy: [
      "Fără obligații",
      "Configurat în 2 minute",
      "Oricând modificabil",
    ],
  },
};

export default LANDINGS;
